import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpRequestService} from './http-request.service';
import {CalculationRequestModel} from '../models/calculation-request.model';
import {OfferRequestModel} from '../models/offer-request.model';
import {PaymentRequestModel} from '../models/payment-request.model';
import {CalcRequestModel} from '../models/calc-request.model';
import {CalcResponseModel} from '../models/calc-response.model';
import {UserRequestModel} from '../models/user-request.model';
import {UserAkModel} from '../models/user-ak.model';
import { CalcfondRequestModel } from '../models/calcfond-request.model';
import { Kolektivmodel } from '../models/kolektiv-clients.model';

@Injectable()
export class CalcApiService {

//private host = 'http://localhost:4964/api/';
//private host = 'https://powerppr.grawe.mk/api/api/';
private host = 'https://power.grawe.mk/api/api/';




  private calculatePremiumsUrl = this.host + 'Calc/CalculatePremium';
  private calculatePremiumsUrlKolektiv = this.host + 'Calc/CalculatePremiumKolek';
  private calculatePremiumsUrlRent = this.host + 'Calc/CalculatePremiumRent';
  private calculatePDFUrl = this.host + 'Calc/PDFInfoPonuda';
  private calculatePDFOfferUrl = this.host + 'Calc/PDFInfoZaUgovaraca';
  private calculatePDFUrlRenta = this.host + 'Calc/PDFInfoPonudaRenta';
  private calculatePDFOfferUrlRenta = this.host + 'Calc/PDFInfoZaUgovaracaRenta';
  private calculatePDFConditions = this.host + 'Calc/PDFUslovi';
  private userUrl = this.host + 'Calc/user';
  private userAKUrl = this.host + 'Calc/ActKod';
  private CalcfondUrl = this.host + 'Calc/CalculationFond';
  private CalcfondJuniorUrl = this.host + 'Calc/CalculationFondJunior';
  private CalcfondJuniorUrlplus = this.host + 'Calc/CalculationFondJuniorPluss';
  private CalcfondSL = this.host + 'Calc/PDFSafeLifeReport';

 // private calculatePremiumsUrl = 'https://www.grawepower.rs/apilife/api/Calc/CalculatePremium';
 // private calculatePremiumsUrlRent = 'https://www.grawepower.rs/apilife/api/Calc/CalculatePremiumRent';
  //private calculatePDFUrl =      'https://www.grawepower.rs/apilife/api/Calc/PDFInfoPonuda';
 // private calculatePDFOfferUrl = 'https://www.grawepower.rs/apilife/api/Calc/PDFInfoZaUgovaraca';
 // private calculatePDFUrlRenta =      'https://www.grawepower.rs/apilife/api/Calc/PDFInfoPonudaRenta';
  //private calculatePDFOfferUrlRenta = 'https://www.grawepower.rs/apilife/api/Calc/PDFInfoZaUgovaracaRenta';
  //private calculatePDFConditions = 'https://www.grawepower.rs/apilife/api/Calc/PDFUslovi';
  //private userUrl = 'https://www.grawepower.rs/apilife/api/Calc/user';
 //private userAKUrl = 'https://www.grawepower.rs/apilife/api/Calc/ActKod';


  //private calculatePremiumsUrl = 'http://localhost:4964/api/Calc/CalculatePremium';
  // private calculatePDFUrl = 'https://localhost:44387/api/calc/PDFInfoOffer';
  // private calculatePDFOfferUrl = 'https://localhost:44387/api/calc/PDFOffer';
  // private userUrl = 'https://localhost:44387/api/calc/user';

  //private calculatePremiumsUrl = 'http://localhost:4964/api/Calc/CalculatePremium';
  //private calculatePremiumsUrlRent = 'http://localhost:4964/api/Calc/CalculatePremiumRent';
  //private calculatePDFUrl =      'http://localhost:4964/api/Calc/PDFInfoPonuda';
  // private calculatePDFOfferUrl = 'http://localhost:4964/api/Calc/PDFInfoZaUgovaraca';
  // private calculatePDFUrlRenta =      'http://localhost:4964/api/Calc/PDFInfoPonudaRenta';
  //private calculatePDFOfferUrlRenta = 'http://localhost:4964/api/Calc/PDFInfoZaUgovaracaRenta';
  //private calculatePDFConditions = 'http://localhost:4964/api/Calc/PDFUslovi';
  //private userUrl = 'http://localhost:4964/api/Calc/user';
  //private userAKUrl = 'http://localhost:4964/api/Calc/ActKod';



  constructor(private http: HttpRequestService) {
  }

  calculate(model: CalcRequestModel) {
    return this.http.post(this.calculatePremiumsUrl, model, false);
  }

  calculateKolektiv(model: Kolektivmodel) {
    return this.http.post(this.calculatePremiumsUrlKolektiv, model, false);
  }

  calculateRent(model: CalcRequestModel) {
    return this.http.post(this.calculatePremiumsUrlRent, model, false);
  }

  downloadpdf(model: CalcResponseModel) {
    return this.http.post(this.calculatePDFUrl, model, false);
  }

  downloadpdfoffer(model: CalcResponseModel) {
    return this.http.post(this.calculatePDFOfferUrl, model, false);
  }

  downloadpdfrenta(model: CalcResponseModel) {
    return this.http.post(this.calculatePDFUrlRenta, model, false);
  }

  downloadpdfofferrenta(model: CalcResponseModel) {
    return this.http.post(this.calculatePDFOfferUrlRenta, model, false);
  }


  downloadpdfconditions(model: CalcResponseModel) {
    return this.http.post(this.calculatePDFConditions, model, false);
  }

  userCheck(model: UserRequestModel) {
    return this.http.post(this.userUrl, model, false);
  }

  userAKCheck(model: UserAkModel) {
    return this.http.post(this.userAKUrl, model, false);
  }

  calculatefond(model: CalcfondRequestModel) {
    return this.http.post(this.CalcfondUrl, model, false);
  }
  calculatefondJunior(model: CalcfondRequestModel) {
    return this.http.post(this.CalcfondJuniorUrl, model, false);
  }
  calculatefondJuniorplus(model: CalcfondRequestModel) {
    return this.http.post(this.CalcfondJuniorUrlplus, model, false);
  }

  
  downloadSlDoc(model: any) {
    return this.http.postBlob(this.CalcfondSL, model,  false);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/calc-api.service.ts